import { useCallback, useMemo } from "react"

export const useGlobalController = () => {
  const switchScroll = useCallback((disable: boolean = false) => {
    document.documentElement.style.scrollbarGutter = "stable"
    if (disable) {
      document.documentElement.style.overflow = "hidden"
    } else {
      document.documentElement.style.overflow = "auto scroll"
    }
  }, [])

  return useMemo(
    () => ({
      switchScroll,
      // other global stuff
    }),
    [switchScroll]
  )
}

export default useGlobalController
